import React, { useState, useEffect, useRef } from 'react'
import { AgGridReact } from "ag-grid-react";
import "../assets/styles/inner/table.scss";
import { Modal } from "./Modal";

export const CSVGridModal = (props) => {
  const emptyRows = useRef([]);
  const Columns = useRef([]);
  const [state, setState] = useState(0)
  const { className, columns, rowData, emptyRowCount, ...rest } = props;
  const getEmptyRows = (count) => {
    let rows = []
    for (let i = 0; i < count; i++) {
      let emptyRow = {};
      columns.forEach((_) => {
        emptyRow[_.field] = '';
      })
      rows.push(emptyRow);
    }
    return rows;
  }
  useEffect(() => {
    Columns.current = columns.map((_) => {
      return { ..._, editable: true }
    })
    if (emptyRowCount) {
      emptyRows.current = getEmptyRows(emptyRowCount);
    }
    setState(state + 1);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <Modal className={`flex-col ${className || ''}`} {...rest}>
      <AgGridReact
        id='ngo-grid'
        suppressCellFocus
        columnDefs={Columns.current}
        className='table-header ngo-grid'
        rowModelType='clientSide'
        suppressPaginationPanel={true}
        animateRows={true} // Optional - set to 'true' to have rows animate when sorted
        columnResize={props.columnResize}
        rowData={(props.rowData || []).concat(emptyRowCount)}
      />
    </Modal>
  )
}